<div class="row mx-3"
     [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr'}">
  <p class="language" (click)="this.internalService.changeLang('en-us', 0)"
     *ngIf="this.apiService.currentDirection ==='rtl'"> En <i class="fa fa-globe"></i></p>
  <p class="language" (click)="this.internalService.changeLang('fa-ir', 0)"
     *ngIf="this.apiService.currentDirection ==='ltr'" style="font-family: 'vazir-regular'!important;">فا <i class="fa fa-globe"></i></p>
  <p class="language" style="cursor: pointer" (click)="LogOut()"><i class="fa fa-sign-out m-rtl-rotate"></i>  {{'Menu.LogOut'|translate}}</p>
</div>

<div class="text-center w-100 pt-4 mx-auto">
    <img class="mx-auto text-center" style="width: 200px; height: auto" src="../../assets/img/forbidden.png"
         alt="Forbidden" title="Forbidden"/>
  <h2 class="mx-auto text-center mt-4">{{'Message.YouDontHavePermissionToAccessThisSite'|translate}}</h2>

</div>






